import React, { useState, useEffect } from 'react';
import importFederatedModule from './importFederatedModule';

export const useFederatedReducer = (ready, scope, module, injectionCb) => {
  const [injected, setInjected] = useState(() => !module);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (ready && !injected) {
      const reducerPromise = importFederatedModule(scope, module);
      reducerPromise()
        .then((reducer) => {
          injectionCb(reducer.default);
          setInjected(true);
        })
        .catch((_) => {
          setError(true);
        });
    }
  }, [injectionCb, module, ready, scope, injected]);

  return { injected, reducerError: error };
};

export const useFederatedComponent = (
  ready,
  reducerInjected,
  scope,
  module
) => {
  const [Component, setComponent] = React.useState(null);

  React.useEffect(() => {
    if (ready && reducerInjected && !Component) {
      const Comp = React.lazy(importFederatedModule(scope, module));
      setComponent(Comp);
    }
  }, [Component, module, ready, reducerInjected, scope]);

  return Component;
};
